import { useContext, useState } from "react";
import ReasonStep from "./PaymentSteps/ReasonStep/ReasonStep";
import PaymentInfoStep from "views/Payment/PaymentSteps";
import useLocalStorage from "components/hooks/useLocalStorage";
import MailTo from "components/common/MailTo";
import Tooltip from "components/common/Tooltip";
import Section from "components/common/Section";
import Button from "components/common/Button";
import Divider from "components/common/Divider";
import {
  ReasonFormInputs,
  PaymentFormInputs,
} from "components/common/common.types";
import { UseFormReturn } from "react-hook-form";
import SelectedOfferContext from "config/selectedOfferContext";
import Popup from "components/common/Popup";
import useScript from "components/hooks/useScript";
import PaymentPay from "./PaymentPay";
import OrderPopupStatus from "./OrderPopupStatus";
import styles from "./Payment.module.scss";
import OrderSummary from "./PaymentSteps/OrderSummary";

const Payment: React.FC = () => {
  const userData = useLocalStorage("userData", {}).storedValue;
  const [isOpen, setOpen] = useState(false);
  const [reasonData, setReasonData] = useState(
    null as unknown as UseFormReturn<ReasonFormInputs, any>
  );
  const [paymentData, setPaymentData] = useState(
    null as unknown as UseFormReturn<PaymentFormInputs, any>
  );
  const [redirectPopup, setRedirectPopup] = useState(false);
  const [paymentResultOpen, setPaymentResultOpen] = useState(false);
  const { selectedOffer } = useContext(SelectedOfferContext);

  useScript(
    `https://ajax.googleapis.com/ajax/libs/jquery/1.11.0/jquery.min.js`
  );

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const changeAddressButton = (
    <div>
      <Button color="primary" border={false} action={() => {}}>
        <p>¿Quieres cambiar de dirección?</p>
      </Button>
    </div>
  );

  const tooltipContent = (
    <div>
      <div className={styles["tooltip-text"]}>
        <p>Envíanos un correo a: </p>
        <MailTo email="beneficios@deacero.com">
          {"beneficios@deacero.com"}
        </MailTo>
      </div>
    </div>
  );

  const addressStep = (
    <Section
      title="1. Revisa tu dirección de envío"
      titleSize="small"
      widthSize="full"
      variant="no-margin-title"
      action={
        <Tooltip
          offset={[4, 10]}
          position="right center"
          triggerTooltip={changeAddressButton}
          isOpen={isOpen}
          handleClose={handleClose}
          handleOpen={handleOpen}
        >
          {tooltipContent}
        </Tooltip>
      }
    >
      {userData.locationData && (
        <p>
          {`${userData.locationData[0].dir.toUpperCase()} ${
            userData.locationData[0].streetnumber
          }`}
          <br />
          {`${userData.locationData[0].neighborhood}, ${userData.locationData[0].postalCode}`}
          <br />
          {`${userData.locationData[0].cityName}, ${userData.locationData[0].stateName}`}
        </p>
      )}
    </Section>
  );

  const setReasonDetails: (
    reasonData: UseFormReturn<ReasonFormInputs, any>
  ) => void = (reasonData: UseFormReturn<ReasonFormInputs, any>) => {
    setReasonData(reasonData);
  };

  const setPaymentDetails: (
    paymentData: UseFormReturn<PaymentFormInputs, any>
  ) => void = (paymentData: UseFormReturn<PaymentFormInputs, any>) => {
    setPaymentData(paymentData);
  };

  if (selectedOffer.title === undefined) {
    const location = window.location.href;
    if (location.split("?")[1]) {
      return (
        <Popup
          open={true}
          onClose={() => {}}
          content={
            <OrderPopupStatus
              setPaymentResultOpen={setPaymentResultOpen}
              redirectMessage={redirectPopup}
            />
          }
        />
      );
    }
  }

  return (
    <Section title="Realiza tu pago">
      <Popup
        open={paymentResultOpen || redirectPopup}
        onClose={() => {}}
        content={
          <OrderPopupStatus
            setPaymentResultOpen={setPaymentResultOpen}
            redirectMessage={redirectPopup}
          />
        }
      />
      <div className={styles.body}>
        {selectedOffer.title && (
          <div className={styles["payment-container"]}>
            <div className={styles["payment-steps"]}>
              {addressStep}
              <Divider color="grey" />
              <OrderSummary />
              <Divider color="grey" />
              <ReasonStep setReasonDetails={setReasonDetails}></ReasonStep>
              <Divider color="grey" />
              <PaymentInfoStep
                setPaymentDetails={setPaymentDetails}
              ></PaymentInfoStep>
            </div>
            <div className={styles["payment-box"]}>
              <PaymentPay
                paymentData={paymentData}
                reasonData={reasonData}
                setPaymentResultOpen={setPaymentResultOpen}
                setRedirectPopupOpen={setRedirectPopup}
              />
            </div>
          </div>
        )}
      </div>
    </Section>
  );
};

export default Payment;
